import { useEffect } from 'react'
import { useMatchScreen } from '../context/MatchScreenContext'
import { evaluateFeatureFlag } from '../utils/featureFlag'
import { FSM_390_USE_LEAD_ENGINE_LEAD_GEN_ENDPOINTS as FLAG } from '../constants/leadEngineFeatureFlags'

let sentRequest = false

// Sending fire and forget request to the send-seen-adv endpoint for a given user's session UUID.
// Gated on FSM-390: when the lead-engine lead-gen endpoints flag is on, hit the lead-engine
// sendSeenAdv URL; otherwise fall back to the funnel-backend URL.
const useSendSeenAdv = () => {
  const { state: { sessionUUID, matches, isPreview } } = useMatchScreen()
  useEffect(() => {
    // Admin previews must never mark advisors as seen — the payload
    // carries a dummy session and the beacon would pollute lead-gen data.
    if (sentRequest || !sessionUUID || isPreview) return
    sentRequest = true

    evaluateFeatureFlag(
      FLAG.flagKey,
      sessionUUID,
      FLAG.defaultValue
    ).then((useLeadEngine: boolean) => {
      // leadUserSessionId is the `sessionId` carried on each match from matches-context
      const leadUserSessionId = matches?.find((match) => match?.sessionId != null)?.sessionId

      if (useLeadEngine) {
        // Lead-engine endpoint takes the params on the query string
        const params = new URLSearchParams({ sessionUUID })
        if (leadUserSessionId != null) {
          params.append('leadUserSessionId', String(leadUserSessionId))
        }
        navigator.sendBeacon(`${leadEngineSendSeenAdvUrl}?${params}`)
        return
      }

      // Funnel-backend endpoint takes the params as multipart form data.
      const formData = new FormData()
      formData.append('sessionUUID', sessionUUID)
      if (leadUserSessionId != null) {
        formData.append('leadUserSessionId', String(leadUserSessionId))
      }
      navigator.sendBeacon(sendSeenAdvUrl, formData)
    })
  }, [sessionUUID, matches, isPreview])
}

export default useSendSeenAdv
